import api from "@/services/api";
import {clearRequestIndicators, prepareRequestIndicators, successRequestIndicators} from "@/services/helper";
import store from "@/store";

export default {
    /**
     * CREATE A PARTIAL USER DATA
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    REG_USER_PARTIAL: async ({ commit }, payload) => {
        prepareRequestIndicators(commit, true)
        
        try {
            const axios = api('node-api')
            const response = await axios.post('/users/partial', payload)
            
            if (response.data.user) {
                commit('setUser', response.data.user)
                successRequestIndicators(commit, response.data.message)
            }
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * GET A USER
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    GET_USER: async ({ commit }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.get(`/users/email/${payload.email}`)
            
            if (response.data.user) {
                commit('setUser', response.data.user)
                successRequestIndicators(commit, response.data.message)
                return response.data.user
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * UPDATE A USER
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    UPDATE_USER: async ({ commit }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.put(`/users/${payload._id}`, payload)
            
            if (response.data.user) {
                commit('setUser', response.data.user)
                successRequestIndicators(commit, response.data.message)
                return response.data.user
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * LOGIN A USER
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    LOGIN_USER: async ({ commit, state }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            axios.defaults.headers.common['x-id-token'] = payload.idToken
            delete payload.idToken
            const response = await axios.post(`/users/login_process`, payload)

            if (response.data.user) {
                commit('setUser', response.data.user)
                commit('setJwt', response.data.token)
                successRequestIndicators(commit, response.data.message)
                return response.data.user
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
}


